import {
  ADD_SPECIALITY,
  CLEAR_ERROR,
  CLEAR_MSG,
  CREATE_USER,
  DELETE_APPOINTMENTS,
  DELETE_SPECIALITY,
  DELETE_USER,
  EDIT_SPECIALITY,
  GET_ALL_APPOINTMENTS,
  GET_ALL_DOCTORS,
  GET_ALL_PATIENTS,
  GET_ALL_USERS,
  GET_DASHBOARD_METRICS,
  GET_SPECIALITY,
  LOGOUT,
  SET,
  SET_ERROR,
  SIGNIN_SUCCESS,
  UPDATE_ADMIN_CREDENTIALS,
} from "src/Actions/Admin/types";

const initialState = {
  token: sessionStorage.getItem("token") || null,
  user: JSON.parse(sessionStorage.getItem("adminInfo")) || null,
  sidebarShow: true,
  appointmentList: [],
  patientList: [],
  metrics: [],
  specialities: [],
  doctorList: [],
  usersList: [],
  msg: null,
  error: null,
};

const adminReducer = (state = initialState, action) => {
  switch (action.type) {

    // User Management Operations
    case SIGNIN_SUCCESS: 
      return {
        ...state,
        token: action.payload.token,
        user: action.payload.adminInfo,
        
      };
    case SET: {
      return {
        ...state,
        sidebarShow: action.payload,
      };
    }
    case UPDATE_ADMIN_CREDENTIALS: {
      return {
        ...state,
        msg: action.payload.message,
      };
    }
    case CREATE_USER: {
      return {
        ...state,
        msg: action.payload.message,
      };
    }
    case DELETE_USER: {
      return {
        ...state,
        msg: action.payload.message,
      };
    }
    case GET_DASHBOARD_METRICS: {
      return {
        ...state,
        metrics: action.payload,
      };
    }
    case LOGOUT:
      return {
        ...state,
        token: null,
        user: null,
      };
    case GET_ALL_USERS: {
        return {
          ...state,
          usersList: action.payload,
        };
    }
    case GET_ALL_DOCTORS: {
        return {
          ...state,
          doctorList: action.payload,
        };
    }
    case GET_ALL_PATIENTS: {
      return {
        ...state,
        patientList: action.payload,
      };
    }

     // Speciality Operations
    case ADD_SPECIALITY: 
      return {
        ...state,
        msg: action.payload.message,
      };
    case GET_SPECIALITY: {
      return {
        ...state,
        specialities: action.payload,
      };
    }
    case DELETE_SPECIALITY: {
      return {
        ...state,
        msg: action.payload.message,
      };
    }
    case EDIT_SPECIALITY: {
      return {
        ...state,
        msg: action.payload.message,
      };
    }

    // Appointment Operations
    case GET_ALL_APPOINTMENTS: {
      return {
        ...state,
        appointmentList: action.payload,
      };
    }
    case DELETE_APPOINTMENTS: {
      return {
        ...state,
        msg: action.payload.message,
      };
    }

    // Error and Response Msg Operations
    case SET_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };
    case CLEAR_MSG:
      return {
        ...state,
        msg: null,
      };
    default:
      return state;
  }
};

export default adminReducer;
